import { useState } from "react";
import PasswordResetPageView from "./PasswordResetPageView";
import useEvaApi, { EvaApiCall } from "../../hooks/useEvaApi";
import { useNavigate } from "react-router-dom";

function PasswordResetPage() {
  const callEvaApi = useEvaApi();
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const [passwordResetData, setPasswordResetData] = useState({
    email: urlParams.get("email"),
    token: urlParams.get("token"),
    password: "",
    password_confirmation: "",
  });
  const [submitError, setSubmitError] = useState(null);

  async function onSubmit() {
    await callEvaApi(
      new EvaApiCall(`password_reset/confirm`)
        .setMethod("POST")
        .setData(passwordResetData)
        .setAlertSuccess(true)
        .setAlertError(true)
        .setErrorState(setSubmitError)
        .setOnSuccess(() => navigate("/login"))
        .setLoadingGroup("reset_password"),
    );
  }

  return (
    <PasswordResetPageView
      passwordResetData={passwordResetData}
      setPasswordResetData={setPasswordResetData}
      onSubmit={onSubmit}
      submitError={submitError}
    />
  );
}

export default PasswordResetPage;
